export const getTableMatrix = ({
    columns,
    rows,
    cellContent,
}: {
    columns: number;
    rows: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    cellContent: ({ column, row }: { column: number; row: number }) => any;
}) =>
    new Array(rows)
        .fill("")
        .map((_, rowIndex) =>
            new Array(columns)
                .fill("")
                .map((_, columnIndex) => cellContent({ column: columnIndex, row: rowIndex }))
        );
